/**
 * Custom context to capture location information
 *
 * @param {Location} location
 * @returns {Object}
 */
export const getLocationContext = (location: Location) => ({
  Hash: location?.hash || '',
  Host: location?.host || '',
  Hostname: location?.hostname || '',
  Href: location?.href || '',
  Origin: location?.origin || '',
  Pathname: location?.pathname || '',
  Port: location?.port || '',
  Protocol: location?.protocol || '',
  Search: location?.search || '',
});
